/* Mobile menu search
   Injects a search field under the mobile menu drawer header. */

(function () {
  'use strict';

  var SEARCH_ROOT_SELECTOR = 'menu-drawer#MenuDrawer, #MenuDrawer.menu-drawer';
  var HEADER_SELECTOR = '.menu-drawer__header';
  var SEARCH_CLASS = 'bm-mobile-menu-search';
  var MOBILE_MQ = '(max-width: 749px)';

  function getSearchAction() {
    var existing = document.querySelector('form[action*="/search"]');
    if (existing) {
      var action = existing.getAttribute('action');
      if (action) return action;
    }
    var root =
      (window.Shopify &&
        Shopify.routes &&
        typeof Shopify.routes.root === 'string' &&
        Shopify.routes.root) ||
      '/';
    if (root.slice(-1) !== '/') root += '/';
    return root + 'search';
  }

  function buildSearchEl() {
    var wrap = document.createElement('div');
    wrap.className = SEARCH_CLASS;
    wrap.setAttribute('data-bm-mobile-menu-search', 'true');

    var form = document.createElement('form');
    form.className = 'bm-mobile-menu-search__form';
    form.setAttribute('role', 'search');
    form.setAttribute('method', 'get');
    form.setAttribute('action', getSearchAction());

    var button = document.createElement('button');
    button.type = 'submit';
    button.className = 'bm-mobile-menu-search__button';
    button.setAttribute('aria-label', 'Search');
    button.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true" focusable="false">' +
      '<circle cx="10.5" cy="10.5" r="6.5" stroke="currentColor" stroke-width="1.5"/>' +
      '<path d="M15.5 15.5L20 20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
      '</svg>';

    var input = document.createElement('input');
    input.type = 'search';
    input.name = 'q';
    input.className = 'bm-mobile-menu-search__input';
    input.placeholder = 'What are you looking for?';
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('autocapitalize', 'off');
    input.setAttribute('enterkeyhint', 'search');
    input.setAttribute('aria-label', 'What are you looking for?');

    form.appendChild(button);
    form.appendChild(input);
    wrap.appendChild(form);

    form.addEventListener('submit', function (event) {
      var term = (input.value || '').trim();
      if (!term) {
        event.preventDefault();
        return;
      }

      event.preventDefault();
      var action = form.getAttribute('action') || getSearchAction();
      var joiner = action.indexOf('?') === -1 ? '?' : '&';
      window.location.href = action + joiner + 'q=' + encodeURIComponent(term);
    });

    return wrap;
  }

  function injectSearch(drawer) {
    if (!drawer || drawer.querySelector('.' + SEARCH_CLASS)) return false;

    var header = drawer.querySelector(HEADER_SELECTOR);
    if (!header || !header.parentNode) return false;

    var searchEl = buildSearchEl();
    if (header.nextSibling) {
      header.parentNode.insertBefore(searchEl, header.nextSibling);
    } else {
      header.parentNode.appendChild(searchEl);
    }
    return true;
  }

  function tryInject() {
    if (!window.matchMedia(MOBILE_MQ).matches) return;
    var drawer = document.querySelector(SEARCH_ROOT_SELECTOR);
    if (!drawer) return;
    injectSearch(drawer);
  }

  function startObserver() {
    if (document.documentElement.getAttribute('data-bm-mobile-menu-search-obs') === '1') {
      return;
    }
    document.documentElement.setAttribute('data-bm-mobile-menu-search-obs', '1');

    var observer = new MutationObserver(function () {
      tryInject();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    tryInject();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }

  window.addEventListener('resize', function () {
    tryInject();
  });
})();
